// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Actions from "../../../../actions/units";
import UnitsList from "./List";

class Units extends Component {
  componentWillMount = () => {
    this.props.dispatch(Actions.fetchUnits());
  };

  onDelete = id => {
    this.props
      .dispatch(Actions.onDelete(id))
      .then(() => this.props.dispatch(Actions.fetchUnits()));
  };

  onChangePage = value => {
    this.props
      .dispatch(Actions.onChangePage(value))
      .then(() => this.props.dispatch(Actions.fetchUnits()));
  };

  onChangeLimit = (current, size) => {
    this.props
      .dispatch(Actions.onChangeLimit(size))
      .then(() => this.props.dispatch(Actions.fetchUnits()));
  };

  render() {
    const { isLoading, units, meta, fetchParams } = this.props;
    return (
      <UnitsList
        loading={isLoading}
        units={units}
        meta={meta}
        fetchParams={fetchParams}
        onDelete={this.onDelete}
        onChangePage={this.onChangePage}
        onChangeLimit={this.onChangeLimit}
      />
    );
  }
}

Units.propTypes = {
  units: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  fetchParams: PropTypes.object,
  meta: PropTypes.object,
  dispatch: PropTypes.func,
  onDelete: PropTypes.func
};

const mapStateToProps = state => ({
  isLoading: state.units.isLoading,
  units: state.units.units,
  meta: state.units.meta,
  fetchParams: state.units.fetchParams,
});

export default connect(mapStateToProps)(Units);
